import { useEffect } from "react";
import { AuthService } from "../auth/AuthService";
import { studentOidcConfig } from "../auth/oidcConfig";

const SilentCallback = () => {
  useEffect(() => {
    const handleSilentCallback = async () => {
      try {
        const authService = new AuthService(studentOidcConfig);
        await authService.handleSilentCallback();
      } catch (error) {
        console.error("靜默 OIDC 回調處理失敗:", error);
      }
    };

    handleSilentCallback();
  }, []);

  return null; // 靜默回調不需要顯示任何內容
};

export default SilentCallback;